module.exports = "/_next/static/images/pytorch-logo-8eadeec9cc88ea62396b982f3b042df8.png";